






























































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import RemoveDesignModal from '@/common/components/RemoveDesignModal.vue'

import { designImagesModal_userDesigns as UserDesign } from '@/common/queries/types/designImagesModal'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { deleteUserDesign } from '@/common/service'

export default Vue.extend({
  components: {
    BaseImage,
    RemoveDesignModal
  },
  props: {
    stockLibraryDesigns: {
      type: Array as () => UserDesign[],
      default: () => []
    },
    selectedDesignId: {
      type: String,
      default: null
    },
    showDefault: {
      type: Boolean,
      default: false
    },
    showRemoveDesign: {
      type: Boolean,
      default: false
    },
    showExtension: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    selectedDesign: UserDesign | null | undefined
    showRemoveDesignModal: boolean
  } {
    return {
      selectedDesign: null,
      showRemoveDesignModal: false
    }
  },
  computed: {
    displayUserDesigns(): UserDesign[] {
      return this.showDefault
        ? this.stockLibraryDesigns
        : this.stockLibraryDesigns.filter(design => !design.isDefault)
    },
    imgPlaceholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  mounted() {
    this.selectedDesign = this.stockLibraryDesigns.find(
      design => design.uuid === this.selectedDesignId
    )
  },
  methods: {
    selectDesign(item: UserDesign) {
      this.selectedDesign = item
      const doSwitchPosition = this.stockLibraryDesigns[0].uuid !== this.selectedDesign!.uuid
      this.$emit(
        'selectDesign',
        { design: this.selectedDesign, switchPosition: doSwitchPosition }
      )
    },
    openRemoveDesignModal(item: UserDesign) {
      this.selectedDesign = item
      this.showRemoveDesignModal = true
    },
    removeDesign() {
      if (!this.selectedDesign) {
        this.showRemoveDesignModal = false
        return
      }
      const removedDesignUuid = this.selectedDesign.uuid
      deleteUserDesign(removedDesignUuid).then((response: any) => {
        if (response.deleteUserDesign.success) {
          this.$emit('removeDesign', removedDesignUuid)
        }
      }).finally(() => {
        this.selectedDesign = null
        this.showRemoveDesignModal = false
      })
    },
    redirectToLogin() {
      window.location.href = `/auth/raksul?path=${encodeURIComponent(window.location.href)}`
      return
    },
    redirectToRegister() {
      window.location.href = `/confirm_login?redirect_url=${encodeURIComponent(window.location.href)}`
      return
    }
  }
})
